import campaignApi from './api/campaignApi';

export const NOTIFICATION_LIST = 'NOTIFICATION/LIST';

const initialState = {
  notifications: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_LIST:
      return {
        ...state,
        notifications: action.payload,
      };
    default:
      return state;
  }
};

export const notificationList = (query = {}) => {
  return dispatch => {
    const params = new URLSearchParams();
    if (query.appId) params.append('appId', query.appId);
    if (query.status) params.append('status', query.status);
    if (query.search) params.append('search', query.search);
    if (query.startDate) params.append('startDate', query.startDate);
    if (query.endDate) params.append('endDate', query.endDate);

    const queryString = params.toString();
    const requestUrl = queryString ? `/notification?${queryString}` : '/notification';

    return campaignApi.get(requestUrl).then(data => {
      dispatch({
        type: NOTIFICATION_LIST,
        payload: data,
      });
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const notificationCreate = (payload) => {
  return dispatch => {
    return campaignApi.post('/notification', payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const notificationUpdate = (id, payload) => {
  return dispatch => {
    return campaignApi.patch(`/notification/${id}`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};
export const notificationDelete = (id) => {
  return dispatch => {
    return campaignApi.delete(`/notification/${id}`).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};

export const notificationTest = (payload) => {
  return dispatch => {
    return campaignApi.post('/notification/test', payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };
};
